import React, {useState} from 'react';

export default function LoginForm({loginFunction, loginError}) {

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");

    function usernameChange(evt) {
        setUsername(evt.target.value);
    }
    
    function passwordChange(evt) {
        setPassword(evt.target.value);
    }

    async function doLogin(evt) {
        evt.preventDefault();
        let result = await loginFunction({ username: username, password: password, useSSO: false });
        setPassword("");
    }

    return <form className="LoginForm" onSubmit={doLogin}>
        <div className="form-group">
            <label htmlFor="username">Username</label>
            <input type="text" className="form-control" required id="username" onChange={usernameChange} />
        </div>
        <div className="form-group">
            <label htmlFor="password">Password</label>
            <input type="password" className="form-control" autoComplete="off" required id="password" onChange={passwordChange} />
        </div>
        <span className="text-danger">{loginError}</span>
        <button type="submit" className="btn btn-primary float-right">Submit</button>
    </form>
}
